/* JAVASCRIPT HELPER FUNCTIONS.  FOR PHP HELPER FUNCTIONS, GO TO /FUNCTIONS/HELPER_FUNCTIONS.PHP */

window.getDynamicTextColor = function(backgroundColor) {
    if (backgroundColor.startsWith('#')) {
        backgroundColor = hexToRgb(backgroundColor);
    }
    let brightness = getBrightness(backgroundColor);

    if (brightness > 127.5) {
        // Light background, apply dark text
        return '#151515' // Dark text
    } else {
        // Dark background, apply light text
        return '#ffffff'; // Light text
    }
}

// export function backgroundIsDark(backgroundColor) {
//     if (backgroundColor.indexOf('#') === 0) {
//         backgroundColor = hexToRgb(backgroundColor);
//     }
//     let brightness = getBrightness(backgroundColor);
    
//     if (brightness > 127.5) {
//         // Light background
//         return false;
//     } else {
//         // Dark background
//         return true;
//     }
// }

window.backgroundIsDark = function(color) {
    let r, g, b, a = 1; // Default alpha to 1 (fully opaque)

    if (typeof color !== "string") {
        console.error("Invalid color input:", color);
        return false;
    }

    if (color.startsWith("#")) {
        color = color.replace("#", "");
        if (color.length === 3) {
            color = color.split("").map(c => c + c).join("");
        }
        if (color.length !== 6) {
            console.error("Invalid hex color:", color);
            return false;
        }
        r = parseInt(color.substring(0, 2), 16);
        g = parseInt(color.substring(2, 4), 16);
        b = parseInt(color.substring(4, 6), 16);
    } else if (color.startsWith("rgba")) {
        let matches = color.match(/[\d.]+/g);
        if (!matches || matches.length < 4) {
            console.error("Invalid RGBA color:", color);
            return false;
        }
        [r, g, b, a] = matches.map(Number);
    } else if (color.startsWith("rgb")) {
        let matches = color.match(/[\d.]+/g);
        if (!matches || matches.length < 3) {
            console.error("Invalid RGB color:", color);
            return false;
        }
        [r, g, b] = matches.map(Number);
    } else {
        console.error("Unrecognized color format:", color);
        return false;
    }

    // Normalize RGB values
    r /= 255;
    g /= 255;
    b /= 255;

    // Apply gamma correction
    const gammaCorrect = (v) => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4));
    r = gammaCorrect(r);
    g = gammaCorrect(g);
    b = gammaCorrect(b);

    // Calculate base luminance (without alpha)
    let baseLuminance = (0.2126 * r) + (0.7152 * g) + (0.0722 * b);

    // Blend with white based on transparency
    let finalLuminance = (baseLuminance * a) + (1.0 * (1 - a));

    // Adjusted threshold for better classification
    return finalLuminance < 0.3;
};



window.getBrightness = function(rgb) {
    const rgbValues = rgb.match(/\d+/g); // Extract the RGB values from the string
    
    // Calculate brightness according to the luminance formula
    const r = parseInt(rgbValues[0]);
    const g = parseInt(rgbValues[1]);
    const b = parseInt(rgbValues[2]);
    
    // Brightness formula: (0.299 * R + 0.587 * G + 0.114 * B)
    const brightness = (0.299 * r + 0.587 * g + 0.114 * b);
    
    return brightness;
}

// Convert HEX to RGB
window.hexToRgb = function(hex) {
    // Remove the hash at the start if it's there
    hex = hex.replace(/^#/, '');
  
    // Parse hex color into RGB components
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
  
    return `rgb(${r}, ${g}, ${b})`;
}

// Convert RGB(A) to HEX
/**
 * Converts RGB(A) to HEX.
 * @param {number|string} r - Red value (0-255) or RGB(A) string.
 * @param {number} [g] - Green value (0-255).
 * @param {number} [b] - Blue value (0-255).
 * @param {number} [a] - Optional alpha value (0-1).
 * @returns {string} - HEX representation of the color.
 */
window.rgbToHex = function(r, g, b, a) {
    // If the first argument is a string, parse it
    if (typeof r === 'string') {
        const regex = /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d*\.?\d+))?\s*\)/i;
        const matches = r.match(regex);

        if (!matches) {
            throw new Error('Invalid RGB(A) string format');
        }

        // Extract values from the matched groups
        r = parseInt(matches[1], 10);
        g = parseInt(matches[2], 10);
        b = parseInt(matches[3], 10);
        a = matches[4] !== undefined ? parseFloat(matches[4]) : undefined;
    }

    // Validate the inputs
    if (typeof r !== 'number' || typeof g !== 'number' || typeof b !== 'number') {
        throw new Error('RGB values must be numbers or a valid RGB(A) string');
    }
    if (r < 0 || r > 255 || g < 0 || g > 255 || b < 0 || b > 255) {
        throw new Error('RGB values must be between 0 and 255');
    }
    if (a !== undefined && (typeof a !== 'number' || a < 0 || a > 1)) {
        throw new Error('Alpha value must be between 0 and 1');
    }

    // Helper function to convert a value to HEX
    const toHex = (value) => {
        const hex = value.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
    };

    const redHex = toHex(r);
    const greenHex = toHex(g);
    const blueHex = toHex(b);

    if (a !== undefined) {
        const alphaHex = toHex(Math.round(a * 255));
        return `#${redHex}${greenHex}${blueHex}${alphaHex}`;
    }

    return `#${redHex}${greenHex}${blueHex}`;
}


// Slugify
window.slugify = function(string) {
    // Replace "&" with "and"
    string = string.replace(/&/g, 'and');
    // Remove single and double quotes (as well as other special quotes)
    string = string.replace(/['"‘’“”]/g, '');
    // Convert to lowercase
    string = string.toLowerCase();
    // Replace non-alphanumeric characters and spaces with hyphens
    string = string.replace(/[^a-z0-9]+/g, '-');
    // Replace multiple hyphens with a single hyphen
    string = string.replace(/-+/g, '-');
    // Trim hyphens from the start and end
    string = string.replace(/^-|-$/g, '');
    return string;
}

window.debounce = function(func, delay) {
    let timer;
    return function (...args) {
        clearTimeout(timer);
        timer = setTimeout(() => func.apply(this, args), delay);
    };
}

window.formatPhoneNumber = function(input) {
    // Strip everything except digits
    let digits = input.value.replace(/\D/g, '').substring(0, 10);

    // Format as (xxx) xxx-xxxx
    if (digits.length >= 7) {
        input.value = '(' + digits.substring(0, 3) + ') ' + digits.substring(3, 6) + '-' + digits.substring(6);
    } else if (digits.length >= 4) {
        input.value = '(' + digits.substring(0, 3) + ') ' + digits.substring(3);
    } else if (digits.length >= 1) {
        input.value = '(' + digits;
    }
}